import { Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  private hubConnection: HubConnection | undefined;
  public data: any;

  constructor(
    private configService: ConfigService
  ) {}

  public startConnection() {
    this.hubConnection = new HubConnectionBuilder()
      .withUrl(`${this.configService.config.signalRWebApiBaseUrl}/homeProgressHub`)
      .configureLogging(LogLevel.Information)
      .withAutomaticReconnect()
      .build();

    this.hubConnection
      .start()
      //.then(() => console.log('Connection started'))
      .catch(err => console.log('Error while starting connection: ' + err));
  }

  public productStatusUpdates() {
    if (this.hubConnection) {
      this.hubConnection.on('productStatusUpdates', (data) => {
        //this.data = data;
        console.log(JSON.stringify(data));
      });
    }
  }
}
